import React from "react";
import { Save, Grid, RefreshCw, Truck } from "lucide-react";
import "./index.css";
import { ViewMode } from "../../../../redux/distributionSlice";

interface HeaderProps {
  viewMode: ViewMode;
  setViewMode: (mode: ViewMode) => void;
  onRefresh: () => void;
  onSave: () => void;
  onDateChange: (date: string) => void;
  onOpenDistribution: () => void;
  selectedDate: string;
  isLoading?: boolean;
  isSaving?: boolean;
  isToday?: boolean;
  hasChanges?: boolean;
  hasNegativeAvailable?: boolean;
  isInitialPlan?: boolean;
}

const Header: React.FC<HeaderProps> = ({
  viewMode,
  setViewMode,
  onRefresh,
  onSave,
  onOpenDistribution,
  isLoading,
  isSaving,
  isToday,
  hasChanges,
  hasNegativeAvailable = false,
  isInitialPlan = false,
}) => {
  return (
    <div className="allocation-management-header">
      <div className="allocation-header-content">
        <div className="allocation-title-section">
          <h1>Direct Sale Allocation</h1>
        </div>
        <div className="allocation-actions-container">
          {/* <div className="date-picker-container">
            <Calendar size={16} className="date-picker-icon" />
            <input
              type="date"
              className="date-picker-input"
              value={selectedDate}
              onChange={(e) => onDateChange(e.target.value)}
            />
          </div> */}

          {/* Only show Save button for today's date */}
       
            <button
              className="action-button action-button--primary"
              onClick={onSave}
              disabled={isSaving || isLoading}
            >
              <Save size={16} className={isSaving ? "spinning" : ""} />
              {isSaving ? "Saving..." : "Save Changes"}
            </button>
      

        
            <div className="distribution-button-container">
              <button
                className="action-button action-button--secondary"
                onClick={onOpenDistribution}
                disabled={
                  isLoading ||
                  isSaving ||
                  hasNegativeAvailable ||
                  hasChanges ||
                  isInitialPlan
                }
                title={
                  isInitialPlan
                    ? "Cannot distribute: This is an initial plan. Save changes first."
                    : hasNegativeAvailable
                    ? "Cannot distribute: Some items have negative available quantity"
                    : hasChanges
                    ? "Save changes before placing an order"
                    : "Open distribution modal"
                }
              >
                <Truck size={16} />
                Place Order(s)
                {hasNegativeAvailable && (
                  <span className="distribution-warning-badge">!</span>
                )}
              </button>
            </div>

          <button
            className="action-button action-button--secondary"
            onClick={onRefresh}
            disabled={isLoading || isSaving}
          >
            <RefreshCw size={16} className={isLoading ? "spinning" : ""} />
            {isLoading ? "Refreshing..." : "Refresh"}
          </button>

          <div className="view-mode-toggle">
            <button
              className={`view-mode-button ${
                viewMode === "grid"
                  ? "view-mode-button--active"
                  : "view-mode-button--active"
              }`}
              onClick={() => setViewMode("grid")}
              disabled={isLoading || isSaving}
            >
              <Grid size={16} />
              Grid
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
